import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";

import PageTitle from "../../layouts/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { create, updateAction } from "../../../store/actions/CommonActions";
import CustomTextarea from "../../components/Forms/CustomInputs/CustomTextarea";
import { getCities, getStates } from "../../../services/CommonServices";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown";
import CustomImageUpload from "../../components/Forms/CustomInputs/CustomImageUpload";
import { removeImageFromPath } from "../../components/Forms/FormHandler";
import { toast } from "react-toastify";
import { apiCaller } from "../../../services/AxiosInstance";

const isSaveSuccess = (response) =>
  response?.data?.success === true ||
  response?.status === 200 ||
  response?.status === 201;

const validationSchema = Yup.object().shape({
  title: Yup.string().required("Venue Name is required"),
  address: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  gates: Yup.number()
    .required("No. of gates is required")
    .integer("No. of gates must be a whole number")
    .min(1, "No. of gates must be at least 1")
    .max(999, "No. of gates cannot exceed 999"),
  location: Yup.string().required("Location is required").url("Invalid URL"),
  description: Yup.string()
    .required("Description is required")
    .test(
      "maxWords",
      "Description must be at most 200 words",
      function (value) {
        if (!value) return true; // required handles empty
        const wordCount = value.trim().split(/\s+/).length;
        return wordCount <= 200;
      }
    ),
});

const AddUpdate = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [selectedCity, setSelectedCity] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const { data: states } = useSelector((state) => state.state);
  const { data: cities } = useSelector((state) => state.city);
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getStates());
  }, []);
  useEffect(() => {
    if (selectedState?.value)
      dispatch(getCities({ state: selectedState.value }));
  }, [selectedState]);
  let initialValues = {
    title: "",
    address: "",
    city: "",
    state: "",
    gates: "",
    location: "",
    description: "",
    banner: "",
    squareImage: ""
  };
  // const statesOptions = State.getStatesOfCountry("IN").map((s) => {
  //   return { ...s, label: s.name, value: s.name };
  // });
  if (state) {
    initialValues = {
      ...state,
      city: state?.city?._id,
      state: state?.state?._id,
    };
  }
  useEffect(() => {
    if (state) {
      // let selectedState = statesOptions.find(
      //   (option) => option.value === state.state
      // );
      // if (selectedState) {
      //   setSelectedStateCode(selectedState.isoCode);
      // }
      setSelectedState({
        label: state.state?.name,
        value: state.state?._id,
      });
      setSelectedCity({
        label: state.city?.name,
        value: state.city?._id,
      });
    }
  }, [state]);

  const uploadFileToServer = async (file) => {
    // 🔍 upload file to server and return the uploaded file url
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await apiCaller({
        method: "post",
        url: "upload",
        params: null,
        data: formData,
      });
      if (res?.data?.data?.url) {
        return res?.data?.data?.url;
      } else {
        throw new Error("Upload failed");
      }
    } catch (err) {
      throw err;
      console.error(err);
      // alert("Error uploading file");
    }
  }

  // console.log("snviosuenvsev", location.state);
  return (
    <Fragment>
      <PageTitle />

      <div className="row">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                {state?._id ? "Edit" : "Add"} New Venue
              </h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      setSubmitting(true);
                      const keysToCheck = ["banner", "squareImage"];
                      for (const [key, value] of Object.entries(values)) {
                        try {
                          if (keysToCheck.findIndex((k) => k === key) !== -1) {
                            const oldValue = initialValues[key];
                            const newValue = values[key];

                            // If old had a value, new is empty/null → remove from server
                            if (oldValue && !newValue) {
                              console.log("Removed:", key, "old path:", oldValue);
                              // Call your API here
                              await removeImageFromPath(oldValue);
                            }
                          }
                        } catch (error) {
                          toast.error("Error removing file");
                          console.error(error);
                          setSubmitting(false);
                          return;
                        }
                        if (value instanceof File) {
                          const file = value;
                          try {
                            // 🔍 upload file
                            const url = await uploadFileToServer(file);
                            // console.log('svnioevs', url);
                            values[key] = url;
                          } catch (err) {
                            toast.error("Error uploading file");
                            console.error(err);
                            setSubmitting(false);
                            return; // stop submit
                          }
                        }
                      }
                      let response;
                      if (state) {
                        response = await updateAction(
                          `venue/${state._id}`,
                          "venue",
                          values
                        );
                      } else {
                        response = await create("venue", "venue", values);
                      }
                      if (isSaveSuccess(response)) {
                        navigate("/venues", { replace: true });
                      }
                    } catch (error) {
                      console.log("snvuisbevsevsdvs322", error);
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <CustomImageUpload
                          fieldName="banner"
                          value={values.banner}
                          error={errors.banner}
                          label={"Upload Venue’s Banner (16:9)"}
                          classes={"col-md-12"}
                          handleBlur={handleBlur}
                          inputType={"text"}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue} />

                        <CustomImageUpload
                          fieldName="squareImage"
                          value={values.squareImage}
                          error={errors.squareImage}
                          label={"Upload Venue’s Square Image (1:1)"}
                          imageRatio="1_1"
                          classes={"col-md-12"}
                          handleBlur={handleBlur}
                          inputType={"text"}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue} />

                        <div
                          className={`form-group col-md-12 mb-3 ${errors.title ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">
                            Name of the Venue
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="input form-control"
                            name="title"
                          />
                          {errors.title && (
                            <div
                              id="val-title-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.title}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-12 mb-3 ${errors.address ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">Address</label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.address}
                            className="input form-control"
                            name="address"
                          />
                          {errors.address && (
                            <div
                              id="val-address-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.address}
                            </div>
                          )}
                        </div>

                        <CustomDropdown
                          fieldName="state"
                          values={selectedState}
                          error={errors.state}
                          label={"State"}
                          classes={"col-md-6"}
                          setFieldValue={setFieldValue}
                          handleChange={(value) => setSelectedState(value)}
                          options={
                            states
                              ? states?.map((data) => {
                                return { label: data.name, value: data._id };
                              })
                              : []
                          }
                        />

                        <CustomDropdown
                          fieldName="city"
                          values={selectedCity}
                          error={errors.city}
                          label={"City"}
                          classes={"col-md-6"}
                          setFieldValue={setFieldValue}
                          handleChange={(value) => setSelectedCity(value)}
                          options={
                            cities && selectedState
                              ? cities?.map((data) => {
                                return { label: data.name, value: data._id };
                              })
                              : []
                          }
                        />

                        <div
                          className={`form-group col-md-12 mb-3 ${errors.gates ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">No. of Gates</label>
                          <input
                            onChange={(e) => {
                              const value = e.target.value;
                              // Remove all non-digit characters (only allow 0-9)
                              const numericValue = value.replace(/[^0-9]/g, '');

                              // Allow empty value for deletion, or valid integer within range
                              if (numericValue === "" || (parseInt(numericValue) >= 1 && parseInt(numericValue) <= 999)) {
                                setFieldValue("gates", numericValue);
                              }
                            }}
                            onBlur={handleBlur}
                            value={values.gates}
                            className="input form-control"
                            name="gates"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {errors.gates && (
                            <div
                              id="val-gates-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.gates}
                            </div>
                          )}
                        </div>

                        <div
                          className={`form-group col-md-12 mb-3 ${errors.location ? "is-invalid" : "is-valid"
                            }`}
                        >
                          <label className="text-label">
                            Google Location Link
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.location}
                            className="input form-control"
                            name="location"
                          />
                          {errors.location && (
                            <div
                              id="val-location-error"
                              class="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.location}
                            </div>
                          )}
                        </div>
                        <CustomTextarea
                          errors={errors}
                          setFieldValue={setFieldValue}
                          handleBlur={handleBlur}
                          values={values}
                        />
                      </div>

                      <div className="float-end">
                        <button
                          type="submit"
                          className="btn me-2 btn-primary"
                          disabled={isSubmitting}
                        >
                          Save
                        </button>
                      </div>
                      {/* <button className="btn btn-danger light">Cancel</button> */}
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddUpdate;
